import axiosClient from '../axiosClient';
import type { AxiosRequestConfig } from 'axios';

export interface WorklistSearchResult {
  databaseObjectId: number;
  systemObjectId: number | null;
  tableDefinitionId: number;
  itemName: string;
  dbSchemaName: string;
  dbViewName: string;
  dbTableName: string;
  dbObjectName: string;
  active: boolean;
  viewExists: boolean;
  description?: string;
  systemObjectName?: string;
  systemObjectPath?: string;
  hasValidSetup: boolean;
}

export interface WorklistSearchResponse {
  results: WorklistSearchResult[];
  totalCount: number;
}

export async function searchWorklists (
  query: string,
  signal?: AbortSignal
): Promise<WorklistSearchResponse> {
  const config: AxiosRequestConfig = {
    params: { query },
    signal
  };

  const response = await axiosClient.get('v2/database/system/search/worklists', config);
  return response.data;
}
